module.exports = __webpack_public_path__ + "static/manta-equipment-logo-light.8a6eb515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manta-equipment-logo-light.png
// module id = 669
// module chunks = 114276838955818